import { render, staticRenderFns } from "./GuppyVideoMessage.vue?vue&type=template&id=16f49eb6&"
import script from "./GuppyVideoMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyVideoMessage.vue?vue&type=script&lang=js&"
import style0 from "./GuppyVideoMessage.vue?vue&type=style&index=0&id=16f49eb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports